import React, {useEffect, useState} from "react";
import {BlockContainer, PageContainer,} from "BaseComponents/Wrappers";
import {FlexContainer} from "BaseComponents/Flex";
import {H1, Ingress} from "BaseComponents/Text/";
import {useGlobal} from "reactn";
import {MapDropdowns} from "Components/LeafletMap/components/MapDropdowns";
import {Leaflet, ResultCardsList} from "Components/LeafletMap/";
import {PrimaryButton, ButtonText} from "Buttons";

let MapCitiesPage = ({
                         Heading,
                         Preamble,
                         MapHits,
                         DirectionsLinkText,
                         SearchMunicipality,
                         SearchMunicipalityHint,
                         Cities,
                         SearchUnit,
                         SearchUnitHint,
                         NoHits,
                         FindUnitText,
                         ActivateMapText,
                         OverlayImage,
                         PreschoolTypes,
                         SearchTypeLabel,
                         SearchTypeHint,
                         ShowPreschoolTypes,
                         ShowUnitTypes,
                         BackgroundColor,
                         SearchFieldText,
                         YouAreHereText,
                         SearchTextUnit,
                         MapHeading,
                         Countries = [],
                         IsCityPage,
                         OverlayDisabled,
                         MapCenter,
                         MapZoom,
                         showBackButton,
                         ViewOtherLocationsText,
                         ParentLink
                     }) => {
    const [markersData, setMarkersData] = useState(MapHits);
    const [unit, setUnit] = useState({});
    const [municipality, setMunicipality] = useState({});
    const [theme] = useGlobal("theme");
    const [mapHitsState, setMapHitsState] = useState(MapHits);
    const [municipalities, setMunicipalities] = useState();
    const [units, setUnits] = useState([]);
    const [types, setTypes] = useState([]);
    const [typeState, setTypeState] = useState([]);
    const [isVisible, setIsVisible] = useState(OverlayDisabled);

    const rest = {
        SearchMunicipality,
        SearchMunicipalityHint,
        SearchUnit,
        SearchUnitHint,
        SearchTypeLabel,
        SearchTypeHint,
        NoHits,
        ShowPreschoolTypes,
        ShowUnitTypes,
    };


    const searchCallback = (data, isEmpty) => {
        if (data.length || (!data.length && !isEmpty)) {
            setMarkersData(data);
        } else {
            setMarkersData(MapHits);
        }
    }

    const municipalityEmpty = (municipality) =>
        Object.keys(municipality).length === 0;

    const selectedNullOrClear = (selected) => {
        let ret = false;
        if (selected !== null && selected.value === undefined) {
            ret = selected.length === 0 && selected.length !== undefined;
        }
        if (!ret) ret = selected === null;
        return ret;
    };

    const updateOrAddUrlParam = (key, value) => {
        const searchParams = new URLSearchParams(window.location.search);

        if (value === '' || value === null || value === undefined) {
            // Delete the parameter if value is empty
            searchParams.delete(key);
        } else {
            // Check if the parameter exists
            if (searchParams.has(key)) {
                // Parameter exists, update it
                searchParams.set(key, value);
            } else {
                // Parameter doesn't exist, add it
                searchParams.append(key, value);
            }
        }
        // Create the new URL with updated parameters
        const newUrl = window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({path: newUrl}, '', newUrl);
    };

    const onChange = (selected, type) => {
        let sortedMarkersData = [];
        if (!selectedNullOrClear(selected)) {
            switch (type) {
                case "municipality":
                    window.location.href = selected.value;
                    break;
                case "unit":
                    let tmp;
                    if (municipalityEmpty(municipality)) {
                        tmp = MapHits.filter((unit) => unit.Name === selected.value);
                        if (tmp !== null) {
                            setMunicipality({
                                value: tmp[0].Municipality,
                                label: tmp[0].Municipality,
                            });
                            setMapHitsState(tmp);
                        }
                    }
                    setUnit(selected);
                    break;
                case "preSchoolType":
                    const s = selected.map((s) => s.value);
                    if (municipalityEmpty(municipality)) {
                        sortedMarkersData = MapHits.filter((el, i) =>
                            el.PreschoolType.some((p) =>
                                s.includes(p)
                            )
                        );
                        setMapHitsState(sortedMarkersData);
                        setMarkersData(sortedMarkersData);
                    } else if (!municipalityEmpty(municipality)) {
                        const s = selected.map((s) => s.value);
                        sortedMarkersData = markersData.filter((el, i) =>
                            el.PreschoolType.some((p) => s.includes(p))
                        );
                        setMapHitsState(sortedMarkersData);
                    }

                    updateOrAddUrlParam('preschooltype', s);
                    setTypeState(selected);

                    break;
            }
        } else {
            if (type === "municipality") {
                setMunicipality({});
                setMarkersData(MapHits);
                setMapHitsState(MapHits);
                setUnit({});
                setTypeState({});
                updateOrAddUrlParam('preschooltype', undefined);
            }
            if (type === "unit") {
                if (!municipalityEmpty(municipality)) {
                    setMarkersData(markersData);
                    setMapHitsState(markersData);
                } else if (municipalityEmpty(municipality)) {
                    setMapHitsState(MapHits);
                    setMarkersData(MapHits);
                }
                setUnit({});

                setTypeState({});
            }
            if (type === "preSchoolType") {
                if (municipalityEmpty(municipality)) {
                    setMapHitsState(MapHits);
                    setMarkersData(MapHits);
                } else {
                    setMarkersData(markersData);
                    setMapHitsState(markersData);
                }

                updateOrAddUrlParam('preschooltype', undefined);
                selected === null && setTypeState([]);
                setUnit({});
            }
        }
    };

    const constructMunicipalities = () => {
        let newMunicipalityList = [];
        Cities?.map((c, i) => {
            newMunicipalityList.push({
                value: c.Url,
                label: c.Name,
            });
        });
        const sortedMunicipalities = newMunicipalityList
            .filter(
                (el, i) =>
                    i === newMunicipalityList.findIndex((elem) => elem.value === el.value)
            )
            .sort((a, b) => a.label && a.label.localeCompare(b.label));
        setMunicipalities(sortedMunicipalities);
    };

    const constructUnits = () => {
        let newUnitsList = [];
        markersData.map(({Name}, i) => {
            newUnitsList.push({
                value: Name,
                label: Name,
            });
        });
        const sortedNewUnitsList = newUnitsList
            .sort((a, b) => a.label && a.label.localeCompare(b.label));
        setUnits(sortedNewUnitsList);
    };

    const constructTypes = () => {
        let typesList = [];
        PreschoolTypes &&
        markersData.map(({PreschoolType}, i) => {
            PreschoolType?.length > 0 &&
            PreschoolType.map((p) => {
                !typesList.includes(p) && typesList.push({value: p, label: p});
            });
        });
        const sortedUniqueTypes = typesList.filter(
            (el, i) => i === typesList.findIndex((elem) => elem.value === el.value)
        ).sort((a, b) => a.label && a.label.localeCompare(b.label));
        setTypes(sortedUniqueTypes);
    };

    useEffect(() => {
        constructMunicipalities();
        constructTypes(markersData);
    }, []);

    useEffect(() => {
        constructUnits(markersData);
        constructTypes(markersData);
    }, [municipality]);

    useEffect(() => {
        if (unit.label !== undefined) {
            let _unit = MapHits.filter(
                (el, i) => i === MapHits.findIndex((elem) => elem.Name === unit.label)
            );
            setMarkersData(_unit);
        }
    }, [unit]);


    useEffect(() => {
        if (typeState.length > 0) {
            let _type = MapHits.filter((el, i) =>
                el.PreschoolType.some((p) =>
                    typeState.map((s) => s.value).includes(p)
                )
            );
            setMarkersData(_type);
        }
    }, [typeState]);

    const handleOverlay = () => {
        if (!isVisible) setIsVisible(true);
    };

    const carView = () => {
        return <ResultCardsList
            markersData={markersData}
            margin="1rem"
            DirectionsLinkText={DirectionsLinkText}
        />
    }

    return (
        <>
            <PageContainer bgColor={theme.colors.lightgrey}>
                <FlexContainer
                    column
                    maxwidth="1252px"
                    smallmargin="0 1rem"
                    margin="0 auto"
                    smallwidth="auto"
                >
                    <FlexContainer column smallmargin="0" smallwidth="auto" width="auto">
                        {Heading && <H1>{Heading}</H1>}
                        {Preamble && (
                            <Ingress maxwidth="870px" margin="0 0 2rem 0">
                                {Preamble}
                            </Ingress>
                        )}
                        {showBackButton && ParentLink?.Url && <PrimaryButton
                            smallmargin="12px 0"
                            padding={"8px 16px "}
                            smallpadding={"8px 16px"}
                            margin={"24px 0 0 0"}
                            minwidthsmall="220px"
                            width={"fit-content"}
                            widthsmall={"fit-content"}
                            href={ParentLink.Url}
                            ariaLabel={ParentLink.Name ?? ViewOtherLocationsText}
                        >
                            <ButtonText display={"flex"} alignItems={"center"} paddingsmall="0" padding="0"
                                        heading={ParentLink.Name ?? ViewOtherLocationsText}>
                                <i className="far fa-arrow-left-long" style={{margin: "0 10px 0 0"}} aria-hidden="true"/>
                                {ViewOtherLocationsText}
                            </ButtonText>
                        </PrimaryButton>}
                        <MapDropdowns
                            handleOverlay={handleOverlay}
                            municipalities={municipalities}
                            types={types}
                            units={units}
                            onChange={(selected, type) => onChange(selected, type)}
                            disabledMunicipality={IsCityPage}
                            {...rest}
                        />
                        <Leaflet
                            height="500px"
                            borderradius={theme.border.radius}
                            zoom={MapZoom}
                            width="100%"
                            center={MapCenter}
                            markersData={mapHitsState}
                            nearestMarkers={markersData}
                            DirectionsLinkText={DirectionsLinkText}
                            FindUnitText={FindUnitText}
                            ActivateMapText={ActivateMapText}
                            handleOverlay={handleOverlay}
                            isVisible={isVisible}
                            OverlayImage={OverlayImage}
                            ShowLocationButton
                        ></Leaflet>

                    </FlexContainer>
                </FlexContainer>
            </PageContainer>
            <BlockContainer>
                <FlexContainer backgroundImage="white" column>
                    <FlexContainer
                        maxwidth="1250px"
                        column
                        smallmargin="0 1rem"
                        margin="0 auto"
                        smallwidth="auto"
                        smallpadding="2rem 0"
                        padding="2rem 0 4rem 0"
                    >
                        {carView()}

                    </FlexContainer>
                </FlexContainer>
            </BlockContainer>
        </>
    );
};

export default MapCitiesPage;
